<template>
  <div class="container-fluid" v-html="items.content"></div>
</template>

<script>
export default {
  props: {
    items: Object,
  },

  mounted() {
    this.$nextTick(() => {
      window.customScripts();
    });
  },
};
</script>

<style lang="scss"></style>
